const getUpgradeUkPlansDictionary = function (data) {
  const upgradeUkPlansDictionary = {
    trademo_intel_uk_pro: {
      name: "Trademo intel UK pro",
      key: "trademo_intel_uk_pro",
      upgradeMessageArrivalDate: "You have access to only historical data. To access recent UK Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageEmailAlert: "You have access to only historical data. To access recent UK Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      upgradeMessageLiveNotification: "You have access to only historical data. To access recent UK Shipments. ", // Need to change the content (Not In Use Right Now)
      dashboardUpgradeMessageEmailAlert: "",
      planFeatures: [
        "UK Shipments Imports and Exports data since Jan 2011",
        "Up to 6 million unique shipments per month",
        "Unlimited Searches",
        "Our customer success managers are available to support you with queries.",
      ],
    },
    trademo_intel_uk_advanced: {
      name: "Trademo intel UK advance",
      key: "trademo_intel_uk_advanced",
      upgradeMessageArrivalDate: "You have access to only historical data. To access recent UK Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageEmailAlert: "You have access to only historical data. To access recent UK Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      upgradeMessageLiveNotification: "You have access to only historical data. To access recent UK Shipments. ", // Need to change the content (Not In Use Right Now)
      dashboardUpgradeMessageEmailAlert: "",
      planFeatures: ["Last 24 months shipments data (updated daily)", "US Census Data based Product Trends for last 24 months", "300,000 shipment downloads per user annually"],
    },
    trademo_intel_uk_enterprise: {
      name: "Trademo intel UK enterprise",
      key: "trademo_intel_uk_enterprise",
      upgradeMessageArrivalDate: "You have access to only historical data. To access recent UK Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageEmailAlert: "You have access to only historical data. To access recent UK Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      upgradeMessageLiveNotification: "You have access to only historical data. To access recent UK Shipments. ", // Need to change the content (Not In Use Right Now)
      dashboardUpgradeMessageEmailAlert: "",
      planFeatures: ["Jan 2011 - Present shipments data (updated daily)", "Unlimited downloads per user"],
    },
  };
  return upgradeUkPlansDictionary;
};
exports.getUpgradeUkPlansDictionary = getUpgradeUkPlansDictionary;
